<section class="content-section">
  <div style="margin-bottom: 24px; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 12px;">
    <a class="btn btn-secondary" style="display: inline-flex; align-items: center; gap: 8px; cursor:pointer;" (click)="naviguerRetour()">
      ← Retour à la liste
    </a>
    <div class="mode-badge" [class.view]="!estModeEdition" [class.edit]="estModeEdition">
      <span>{{ estModeEdition ? '✏️ MODE ÉDITION' : '🔒 MODE LECTURE' }}</span>
    </div>
  </div>

  <!-- VIEW MODE: Read-only display -->
  <ng-container *ngIf="!estModeEdition && formulaireUtilisateur.value.id">
    <div class="view-mode-container">
      <div class="form-section">
        <h3 class="form-section-title">Informations personnelles</h3>
        <div class="view-item-row">
          <div class="view-item">
            <label class="view-label">Nom</label>
            <p class="view-value">{{ formulaireUtilisateur.get('nom')?.value }}</p>
          </div>
          <div class="view-item">
            <label class="view-label">Prénom(s)</label>
            <p class="view-value">{{ formulaireUtilisateur.get('prenom')?.value }}</p>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section-title">Informations de contact</h3>
        <div class="view-item">
          <label class="view-label">Adresse e-mail</label>
          <p class="view-value">{{ formulaireUtilisateur.get('email')?.value }}</p>
        </div>
        <div class="view-item-row">
          <div class="view-item">
            <label class="view-label">Téléphone</label>
            <p class="view-value">{{ formulaireUtilisateur.get('telephone')?.value }}</p>
          </div>
          <div class="view-item">
            <label class="view-label">Adresse</label>
            <p class="view-value">{{ formulaireUtilisateur.get('adresse')?.value || '—' }}</p>
          </div>
        </div>
        <div class="view-item" *ngIf="formulaireUtilisateur.get('username')?.value">
          <label class="view-label">Nom d'utilisateur</label>
          <p class="view-value">{{ formulaireUtilisateur.get('username')?.value }}</p>
        </div>
      </div>

      <div class="form-section">
        <h3 class="form-section-title">Profil utilisateur</h3>
        <div class="view-role-card" *ngIf="formulaireUtilisateur.get('role')?.value"
             [attr.data-role]="formulaireUtilisateur.get('role')?.value">
          <i [class]="roleIcone(formulaireUtilisateur.get('role')?.value)"></i>
          <div>
            <strong>{{ obtenirLibelleType(formulaireUtilisateur.get('typeUtilisateur')?.value) }}</strong>
            <span>{{ roleDescription(formulaireUtilisateur.get('role')?.value) }}</span>
          </div>
        </div>
        <div class="view-item" *ngIf="estResponsableZoneSelectionne(formulaireUtilisateur.get('typeUtilisateur')?.value)"
             style="margin-top: 12px;">
          <label class="view-label">Zones gérées</label>
          <div style="display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px;">
            <ng-container *ngIf="(formulaireUtilisateur.get('zoneIds')?.value || []).length > 0; else aucuneZone">
              <span *ngFor="let id of formulaireUtilisateur.get('zoneIds')?.value" class="view-zone-tag">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ obtenirNomZone(id) }}
              </span>
            </ng-container>
            <ng-template #aucuneZone><span class="view-value">—</span></ng-template>
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           PROFIL LIVREUR (palier · courses · gains · note · véhicule · documents)
           ▶ Réplique sur le web ce que le livreur voit dans son app mobile.
           ═══════════════════════════════════════════════════════════════════ -->
      <ng-container *ngIf="estLivreurSelectionne()">

        <!-- Bandeau Hero (palier + stats) -->
        <div class="form-section profil-livreur-hero" *ngIf="statsLivreur">
          <div class="hero-stats">
            <div class="hero-avatar">
              {{ ((formulaireUtilisateur.get('prenom')?.value || '?')[0] || '') + ((formulaireUtilisateur.get('nom')?.value || '?')[0] || '') | uppercase }}
            </div>
            <div class="hero-info">
              <div class="hero-palier">
                <i class="fal fa-medal"></i>
                <span><strong>Livreur {{ statsLivreur.palier?.label }}</strong> · Niveau {{ statsLivreur.palier?.niveau }}</span>
              </div>
              <div class="hero-progression">
                <div class="hero-progress-bar">
                  <div class="hero-progress-fill" [style.width.%]="(statsLivreur.palier?.progression || 0) * 100"></div>
                </div>
                <small *ngIf="statsLivreur.palier?.restantes > 0">
                  {{ statsLivreur.palier?.restantes }} courses pour atteindre {{ palierSuivant(statsLivreur.palier?.niveau) }}
                </small>
                <small *ngIf="statsLivreur.palier?.restantes === 0">Niveau maximum atteint</small>
              </div>
            </div>
          </div>
          <div class="hero-kpis">
            <div class="hero-kpi">
              <i class="fal fa-star"></i>
              <strong>{{ statsLivreur.noteMoyenne != null ? (statsLivreur.noteMoyenne | number:'1.1-1') : '—' }}</strong>
              <small>Note ({{ statsLivreur.nbAvis }} avis)</small>
            </div>
            <div class="hero-kpi">
              <i class="fal fa-motorcycle"></i>
              <strong>{{ statsLivreur.coursesLivrees }}</strong>
              <small>Courses livrées</small>
            </div>
            <div class="hero-kpi">
              <i class="fal fa-coins"></i>
              <strong>{{ formatGainsCompact(statsLivreur.gainsTotaux) }}</strong>
              <small>Gains (FCFA)</small>
            </div>
          </div>
        </div>

        <!-- ═════════════════════════════════════════════════════════════════
             SALAIRE & POINT DU MOIS (depuis fiche RH si elle existe)
             ═════════════════════════════════════════════════════════════════ -->
        <div class="form-section" *ngIf="fichePersonnelExistante">
          <div class="section-header-actions">
            <h3 class="form-section-title">
              <i class="fal fa-coins"></i> Salaire & Point du mois
            </h3>
            <div class="section-action-btns">
              <button type="button" class="btn-action btn-action-primary"
                      [disabled]="generationPrimeEnCours"
                      (click)="genererPrimeMoisCourant()">
                <i class="fal fa-bolt"></i>
                {{ generationPrimeEnCours ? 'Génération…' : 'Générer la prime du mois' }}
              </button>
            </div>
          </div>

          <div class="rh-summary-grid">
            <div class="rh-summary-card">
              <small>Type de contrat</small>
              <strong>{{ libellesRH[fichePersonnelExistante.typeContrat || ''] || fichePersonnelExistante.typeContrat || '—' }}</strong>
            </div>
            <div class="rh-summary-card">
              <small>Rémunération</small>
              <strong>{{ libellesRH[fichePersonnelExistante.modeRemuneration || ''] || fichePersonnelExistante.modeRemuneration || '—' }}</strong>
            </div>
            <div class="rh-summary-card" *ngIf="fichePersonnelExistante.salaireBase != null">
              <small>Salaire de base</small>
              <strong>{{ fichePersonnelExistante.salaireBase | number }} FCFA</strong>
            </div>
            <div class="rh-summary-card" *ngIf="fichePersonnelExistante.tarifParLivraison != null">
              <small>Tarif / livraison</small>
              <strong>{{ fichePersonnelExistante.tarifParLivraison | number }} FCFA</strong>
            </div>
            <div class="rh-summary-card">
              <small>Date d'embauche</small>
              <strong>{{ fichePersonnelExistante.dateEmbauche || '—' }}</strong>
            </div>
            <div class="rh-summary-card" *ngIf="fichePersonnelExistante.numeroMatricule">
              <small>Matricule</small>
              <strong>{{ fichePersonnelExistante.numeroMatricule }}</strong>
            </div>
            <div class="rh-summary-card" *ngIf="fichePersonnelExistante.pointsCumules != null">
              <small>Points cumulés (tout temps)</small>
              <strong>{{ fichePersonnelExistante.pointsCumules | number }} pts</strong>
            </div>
          </div>

          <!-- Relevé du mois en cours -->
          <div class="rh-releve" *ngIf="releveMoisCourant">
            <h4 style="margin: 16px 0 8px 0;">
              <i class="fal fa-calendar-day"></i> Relevé — {{ formatMoisAnnee(releveMoisCourant.moisAnnee) }}
            </h4>
            <div class="rh-summary-grid">
              <div class="rh-summary-card">
                <small>Livraisons du mois</small>
                <strong>{{ releveMoisCourant.nbLivraisons || 0 }}</strong>
              </div>
              <div class="rh-summary-card">
                <small>Points du mois</small>
                <strong>{{ releveMoisCourant.totalPoints || 0 }} pts</strong>
              </div>
              <div class="rh-summary-card" *ngIf="releveMoisCourant.montantBase != null">
                <small>Base estimée</small>
                <strong>{{ releveMoisCourant.montantBase | number }} FCFA</strong>
              </div>
              <div class="rh-summary-card" *ngIf="releveMoisCourant.montantPrime != null">
                <small>Prime estimée</small>
                <strong>{{ releveMoisCourant.montantPrime | number }} FCFA</strong>
              </div>
            </div>
          </div>

          <!-- Mini-graphique 6 derniers mois -->
          <div *ngIf="(historiquePrimes?.length || 0) > 0" style="margin-top: 16px;">
            <h4 style="margin: 8px 0;">
              <i class="fal fa-chart-line"></i> Évolution sur 6 mois
            </h4>
            <div echarts [options]="optionsGraphiquePrimes" class="chart-container" style="height: 220px"></div>
          </div>

          <!-- Tableau historique -->
          <div *ngIf="(historiquePrimes?.length || 0) > 0" style="margin-top: 16px;">
            <h4 style="margin: 8px 0;">
              <i class="fal fa-history"></i> Historique des primes
            </h4>
            <table class="rh-primes-table">
              <thead>
                <tr>
                  <th>Mois</th>
                  <th>Livraisons</th>
                  <th>Points</th>
                  <th>Base</th>
                  <th>Prime</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of historiquePrimes">
                  <td>{{ formatMoisAnnee(p.moisAnnee) }}</td>
                  <td>{{ p.nbLivraisons || 0 }}</td>
                  <td>{{ p.totalPoints || 0 }}</td>
                  <td>{{ (p.montantBase || 0) | number }}</td>
                  <td><strong>{{ (p.montantPrime || 0) | number }}</strong></td>
                  <td><span class="badge" [class]="badgeStatutPrime(p.statut)">{{ libelleStatutPrime(p.statut) }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>

          <p *ngIf="historiquePrimes?.length === 0 && !chargementHistoriquePrimes"
             style="color: var(--text-secondary); margin-top: 12px;">
            <i class="fal fa-info-circle"></i> Aucune prime générée pour ce livreur.
          </p>
        </div>

        <!-- Pas de fiche RH : invitation -->
        <div class="form-section" *ngIf="!fichePersonnelExistante && !chargementProfilLivreur"
             style="border-left: 4px solid var(--accent-color, #f59e0b); background: #fffbeb;">
          <h3 class="form-section-title" style="color: #92400e;">
            <i class="fal fa-exclamation-triangle"></i> Aucune fiche RH
          </h3>
          <p style="margin: 8px 0;">
            Ce livreur n'a pas de fiche RH : aucune rémunération n'est configurée et les points ne sont pas crédités.
            Activez la section "Informations RH" plus bas pour créer la fiche.
          </p>
        </div>

        <!-- Véhicule (DEMATRAL ou PARTENAIRE) -->
        <div class="form-section">
          <div class="section-header-actions">
            <h3 class="form-section-title">
              <i class="fal fa-truck"></i> Véhicule
            </h3>
            <div class="section-action-btns">
              <button *ngIf="profilLivreur?.vehiculeActuel && !afficherFormulaireVehicule"
                      type="button" class="btn-action btn-action-secondary"
                      (click)="confirmerDesassignation()">
                <i class="fal fa-unlink"></i> Désassigner
              </button>
              <button *ngIf="!afficherFormulaireVehicule"
                      type="button" class="btn-action btn-action-primary"
                      (click)="ouvrirFormulaireVehicule()">
                <i class="fal" [class.fa-edit]="profilLivreur?.vehiculeActuel" [class.fa-plus]="!profilLivreur?.vehiculeActuel"></i>
                {{ profilLivreur?.vehiculeActuel ? 'Modifier' : 'Assigner un véhicule' }}
              </button>
              <button *ngIf="afficherFormulaireVehicule" type="button"
                      class="btn-action btn-action-ghost" (click)="fermerFormulaireVehicule()">
                <i class="fal fa-times"></i> Annuler
              </button>
            </div>
          </div>

          <div *ngIf="chargementProfilLivreur" class="profil-loading">
            <i class="fal fa-spinner"></i> Chargement…
          </div>

          <!-- Formulaire inline assignation/modification véhicule -->
          <div *ngIf="afficherFormulaireVehicule" class="inline-form-panel">
            <h4 class="inline-form-title">
              {{ profilLivreur?.vehiculeActuel ? 'Modifier les informations du véhicule' : 'Assigner un véhicule' }}
            </h4>

            <!-- Type de flotte -->
            <div class="inline-form-group">
              <label class="inline-form-label">Type de flotte *</label>
              <div class="flotte-type-radios">
                <label class="flotte-radio" [class.flotte-radio-active]="vehiculeForm.typeFlotte === 'DEMATRAL'"
                       (click)="vehiculeForm.typeFlotte = 'DEMATRAL'">
                  <i class="fal fa-building"></i>
                  <span>Flotte Dematral</span>
                  <small>Véhicule appartenant à Dematral</small>
                </label>
                <label class="flotte-radio" [class.flotte-radio-active]="vehiculeForm.typeFlotte === 'PARTENAIRE'"
                       (click)="vehiculeForm.typeFlotte = 'PARTENAIRE'">
                  <i class="fal fa-handshake"></i>
                  <span>Partenaire</span>
                  <small>Véhicule d'un prestataire externe</small>
                </label>
              </div>
            </div>

            <div class="inline-form-row">
              <div class="inline-form-group">
                <label class="inline-form-label">Immatriculation *</label>
                <input type="text" class="form-input" placeholder="Ex: AB-1234-CI"
                       [(ngModel)]="vehiculeForm.immatriculation">
              </div>
              <div class="inline-form-group">
                <label class="inline-form-label">Marque *</label>
                <input type="text" class="form-input" placeholder="Ex: Honda"
                       [(ngModel)]="vehiculeForm.marque">
              </div>
              <div class="inline-form-group">
                <label class="inline-form-label">Modèle *</label>
                <input type="text" class="form-input" placeholder="Ex: CB125F"
                       [(ngModel)]="vehiculeForm.modele">
              </div>
            </div>
            <div class="inline-form-row">
              <div class="inline-form-group">
                <label class="inline-form-label">Couleur</label>
                <input type="text" class="form-input" placeholder="Ex: Rouge"
                       [(ngModel)]="vehiculeForm.couleur">
              </div>
              <div class="inline-form-group">
                <label class="inline-form-label">N° de châssis</label>
                <input type="text" class="form-input" placeholder="Optionnel"
                       [(ngModel)]="vehiculeForm.numeroChassis">
              </div>
            </div>

            <!-- Champs spécifiques partenaire -->
            <ng-container *ngIf="vehiculeForm.typeFlotte === 'PARTENAIRE'">
              <div class="inline-form-separator"><span>Informations partenaire</span></div>
              <div class="inline-form-row">
                <div class="inline-form-group">
                  <label class="inline-form-label">Nom du propriétaire</label>
                  <input type="text" class="form-input" placeholder="Ex: Koné Mamadou"
                         [(ngModel)]="vehiculeForm.nomProprietaire">
                </div>
                <div class="inline-form-group">
                  <label class="inline-form-label">Contact propriétaire</label>
                  <input type="tel" class="form-input" placeholder="Ex: 07 00 00 00 00"
                         [(ngModel)]="vehiculeForm.contactProprietaire">
                </div>
              </div>
              <div class="inline-form-row">
                <div class="inline-form-group">
                  <label class="inline-form-label">Type de contrat</label>
                  <select class="form-select" [(ngModel)]="vehiculeForm.typeContrat">
                    <option value="">Sélectionner…</option>
                    <option value="PAR_LIVRAISON">Par livraison</option>
                    <option value="FORFAIT_MENSUEL">Forfait mensuel</option>
                    <option value="MIXTE">Mixte</option>
                  </select>
                </div>
                <div class="inline-form-group" *ngIf="vehiculeForm.typeContrat === 'PAR_LIVRAISON' || vehiculeForm.typeContrat === 'MIXTE'">
                  <label class="inline-form-label">Montant / livraison (FCFA)</label>
                  <input type="number" class="form-input" placeholder="0"
                         [(ngModel)]="vehiculeForm.montantParLivraison">
                </div>
                <div class="inline-form-group" *ngIf="vehiculeForm.typeContrat === 'FORFAIT_MENSUEL' || vehiculeForm.typeContrat === 'MIXTE'">
                  <label class="inline-form-label">Forfait mensuel (FCFA)</label>
                  <input type="number" class="form-input" placeholder="0"
                         [(ngModel)]="vehiculeForm.montantMensuel">
                </div>
              </div>
            </ng-container>

            <div class="inline-form-actions">
              <button type="button" class="btn btn-secondary" (click)="fermerFormulaireVehicule()">Annuler</button>
              <button type="button" class="btn btn-primary"
                      [disabled]="enregistrementVehiculeEnCours"
                      (click)="soumettreFormulaireVehicule()">
                <i class="fal fa-spinner" *ngIf="enregistrementVehiculeEnCours"></i>
                {{ enregistrementVehiculeEnCours ? 'Enregistrement…' : (profilLivreur?.vehiculeActuel ? 'Enregistrer les modifications' : 'Assigner ce véhicule') }}
              </button>
            </div>
          </div>

          <!-- Affichage véhicule actuel -->
          <div *ngIf="!afficherFormulaireVehicule && !chargementProfilLivreur && !profilLivreur?.vehiculeActuel" class="profil-vide">
            <i class="fal fa-times-circle"></i> Aucun véhicule assigné à ce livreur.
          </div>
          <div *ngIf="!afficherFormulaireVehicule && profilLivreur?.vehiculeActuel" class="vehicule-card">
            <div class="vehicule-card-header">
              <div class="vehicule-immat">
                <i class="fal fa-car-side"></i>
                <strong>{{ profilLivreur.vehiculeActuel.immatriculation }}</strong>
              </div>
              <span class="badge-flotte"
                    [class.flotte-dematral]="profilLivreur.vehiculeActuel.typeFlotte === 'DEMATRAL'"
                    [class.flotte-partenaire]="profilLivreur.vehiculeActuel.typeFlotte === 'PARTENAIRE'">
                <i class="fal" [class.fa-building]="profilLivreur.vehiculeActuel.typeFlotte === 'DEMATRAL'"
                              [class.fa-handshake]="profilLivreur.vehiculeActuel.typeFlotte === 'PARTENAIRE'"></i>
                {{ profilLivreur.vehiculeActuel.typeFlotte === 'PARTENAIRE' ? 'Partenaire' : 'Flotte Dematral' }}
              </span>
            </div>
            <div class="vehicule-grid">
              <div><label>Marque</label><span>{{ profilLivreur.vehiculeActuel.marque || '—' }}</span></div>
              <div><label>Modèle</label><span>{{ profilLivreur.vehiculeActuel.modele || '—' }}</span></div>
              <div><label>Couleur</label><span>{{ profilLivreur.vehiculeActuel.couleur || '—' }}</span></div>
              <div *ngIf="profilLivreur.vehiculeActuel.numeroChassis"><label>N° châssis</label><span>{{ profilLivreur.vehiculeActuel.numeroChassis }}</span></div>
              <div *ngIf="profilLivreur.vehiculeActuel.typeFlotte === 'PARTENAIRE'">
                <label>Propriétaire</label>
                <span>{{ profilLivreur.vehiculeActuel.nomProprietaire || '—' }}</span>
              </div>
              <div *ngIf="profilLivreur.vehiculeActuel.typeFlotte === 'PARTENAIRE' && profilLivreur.vehiculeActuel.contactProprietaire">
                <label>Contact</label><span>{{ profilLivreur.vehiculeActuel.contactProprietaire }}</span>
              </div>
              <div *ngIf="profilLivreur.vehiculeActuel.typeFlotte === 'PARTENAIRE' && profilLivreur.vehiculeActuel.typeContrat">
                <label>Type de contrat</label><span>{{ profilLivreur.vehiculeActuel.typeContrat }}</span>
              </div>
              <div *ngIf="profilLivreur.vehiculeActuel.montantParLivraison">
                <label>Montant / livraison</label><span>{{ profilLivreur.vehiculeActuel.montantParLivraison | number }} F</span>
              </div>
              <div *ngIf="profilLivreur.vehiculeActuel.montantMensuel">
                <label>Forfait mensuel</label><span>{{ profilLivreur.vehiculeActuel.montantMensuel | number }} F</span>
              </div>
            </div>
            <div class="vehicule-stats" *ngIf="profilLivreur.vehiculeActuel.livraisonsMois != null || profilLivreur.vehiculeActuel.montantGenereMois != null">
              <span><i class="fal fa-box"></i> {{ profilLivreur.vehiculeActuel.livraisonsMois || 0 }} livraisons / mois</span>
              <span><i class="fal fa-sack-dollar"></i> {{ profilLivreur.vehiculeActuel.montantGenereMois | number }} F générés</span>
            </div>
          </div>
        </div>

        <!-- Documents (perso + véhicule) -->
        <div class="form-section">
          <div class="section-header-actions">
            <h3 class="form-section-title">
              <i class="fal fa-folder"></i> Documents
              <small *ngIf="profilLivreur" style="font-weight:400; font-size:13px; color:#64748b; margin-left:8px;">
                ({{ profilLivreur.nombreDocumentsValides }}/{{ profilLivreur.nombreDocumentsTotal }} validés)
              </small>
            </h3>
            <div class="section-action-btns">
              <button *ngIf="!afficherFormulaireDocument"
                      type="button" class="btn-action btn-action-primary"
                      (click)="ouvrirFormulaireDocument()">
                <i class="fal fa-plus"></i> Ajouter un document
              </button>
              <button *ngIf="afficherFormulaireDocument" type="button"
                      class="btn-action btn-action-ghost" (click)="fermerFormulaireDocument()">
                <i class="fal fa-times"></i> Annuler
              </button>
            </div>
          </div>

          <div *ngIf="chargementProfilLivreur" class="profil-loading"><i class="fal fa-spinner"></i> Chargement…</div>

          <!-- Formulaire inline ajout document -->
          <div *ngIf="afficherFormulaireDocument" class="inline-form-panel">
            <h4 class="inline-form-title">Ajouter un document</h4>
            <div class="inline-form-row">
              <div class="inline-form-group">
                <label class="inline-form-label">Type de document *</label>
                <select class="form-select" [(ngModel)]="documentForm.type">
                  <option value="">Sélectionner…</option>
                  <optgroup label="Documents personnels">
                    <option value="CNI">CNI</option>
                    <option value="PERMIS">Permis de conduire</option>
                  </optgroup>
                  <optgroup label="Documents véhicule">
                    <option value="CARTE_GRISE">Carte grise</option>
                    <option value="ATTESTATION_ASSURANCE">Attestation assurance</option>
                  </optgroup>
                </select>
                <small *ngIf="documentForm.type && ['CARTE_GRISE','ATTESTATION_ASSURANCE'].includes(documentForm.type) && !profilLivreur?.vehiculeActuel"
                       style="color:#f59e0b; display:block; margin-top:4px;">
                  <i class="fal fa-exclamation-triangle"></i> Assignez d'abord un véhicule pour ce type de document.
                </small>
              </div>
              <div class="inline-form-group">
                <label class="inline-form-label">Numéro</label>
                <input type="text" class="form-input" placeholder="Numéro du document"
                       [(ngModel)]="documentForm.numero">
              </div>
            </div>
            <div class="inline-form-row">
              <div class="inline-form-group">
                <label class="inline-form-label">Date d'émission</label>
                <input type="date" class="form-input" [(ngModel)]="documentForm.dateEmission">
              </div>
              <div class="inline-form-group">
                <label class="inline-form-label">Date d'expiration</label>
                <input type="date" class="form-input" [(ngModel)]="documentForm.dateExpiration">
              </div>
            </div>
            <div class="inline-form-group">
              <label class="inline-form-label">Commentaire</label>
              <input type="text" class="form-input" placeholder="Remarque optionnelle"
                     [(ngModel)]="documentForm.commentaire">
            </div>
            <div class="inline-form-actions">
              <button type="button" class="btn btn-secondary" (click)="fermerFormulaireDocument()">Annuler</button>
              <button type="button" class="btn btn-primary"
                      [disabled]="enregistrementDocumentEnCours"
                      (click)="soumettreFormulaireDocument()">
                <i class="fal fa-spinner" *ngIf="enregistrementDocumentEnCours"></i>
                {{ enregistrementDocumentEnCours ? 'Enregistrement…' : 'Ajouter le document' }}
              </button>
            </div>
          </div>

          <div *ngIf="!afficherFormulaireDocument && !chargementProfilLivreur && (!profilLivreur || profilLivreur.nombreDocumentsTotal === 0)" class="profil-vide">
            <i class="fal fa-folder-open"></i> Aucun document enregistré pour ce livreur.
          </div>

          <ng-container *ngIf="profilLivreur && profilLivreur.nombreDocumentsTotal > 0">
            <div *ngIf="documentsPerso().length" class="docs-bloc">
              <h4 class="docs-titre">Documents personnels</h4>
              <div class="docs-grid">
                <div *ngFor="let d of documentsPerso()" class="doc-card"
                     [class.doc-valide]="d.statut === 'VALIDE'"
                     [class.doc-rejete]="d.statut === 'REJETE'"
                     [class.doc-attente]="d.statut === 'EN_ATTENTE'">
                  <i class="fal fa-file-alt doc-icone"></i>
                  <div class="doc-info">
                    <strong>{{ typeDocumentLibelle(d.type) }}</strong>
                    <small *ngIf="d.numero">N° {{ d.numero }}</small>
                    <small *ngIf="d.dateExpiration">Expire : {{ d.dateExpiration | date:'dd/MM/yyyy' }}</small>
                  </div>
                  <div class="doc-actions">
                    <span class="doc-statut">{{ d.statut }}</span>
                    <div class="doc-statut-btns">
                      <button *ngIf="d.statut !== 'VALIDE'" type="button" class="doc-btn-valider"
                              title="Valider" (click)="modifierStatutDoc(d, 'VALIDE')">✓</button>
                      <button *ngIf="d.statut !== 'REJETE'" type="button" class="doc-btn-rejeter"
                              title="Rejeter" (click)="modifierStatutDoc(d, 'REJETE')">✕</button>
                      <button type="button" class="doc-btn-supprimer"
                              title="Supprimer" (click)="supprimerDoc(d)">🗑</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="documentsVehicule().length" class="docs-bloc">
              <h4 class="docs-titre">Documents véhicule</h4>
              <div class="docs-grid">
                <div *ngFor="let d of documentsVehicule()" class="doc-card"
                     [class.doc-valide]="d.statut === 'VALIDE'"
                     [class.doc-rejete]="d.statut === 'REJETE'"
                     [class.doc-attente]="d.statut === 'EN_ATTENTE'">
                  <i class="fal fa-file-alt doc-icone"></i>
                  <div class="doc-info">
                    <strong>{{ typeDocumentLibelle(d.type) }}</strong>
                    <small *ngIf="d.numero">N° {{ d.numero }}</small>
                    <small *ngIf="d.dateExpiration">Expire : {{ d.dateExpiration | date:'dd/MM/yyyy' }}</small>
                  </div>
                  <div class="doc-actions">
                    <span class="doc-statut">{{ d.statut }}</span>
                    <div class="doc-statut-btns">
                      <button *ngIf="d.statut !== 'VALIDE'" type="button" class="doc-btn-valider"
                              title="Valider" (click)="modifierStatutDoc(d, 'VALIDE')">✓</button>
                      <button *ngIf="d.statut !== 'REJETE'" type="button" class="doc-btn-rejeter"
                              title="Rejeter" (click)="modifierStatutDoc(d, 'REJETE')">✕</button>
                      <button type="button" class="doc-btn-supprimer"
                              title="Supprimer" (click)="supprimerDoc(d)">🗑</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

      </ng-container>

      <div class="form-actions">
        <a
          *ngIf="estLivreurSelectionne()"
          [routerLink]="['/utilisateur/livreur', formulaireUtilisateur.value.id, 'livraisons']"
          [queryParams]="{ nom: (formulaireUtilisateur.get('prenom')?.value || '') + ' ' + (formulaireUtilisateur.get('nom')?.value || '') }"
          class="btn btn-secondary">
          Voir ses livraisons
        </a>
        <a class="btn btn-secondary" style="cursor:pointer;" (click)="naviguerRetour()">Retour</a>
        <button type="button" class="btn btn-primary" (click)="estModeEdition = true">Modifier</button>
      </div>
    </div>
  </ng-container>

  <!-- EDIT MODE: Form -->
  <form class="form-container" [class.edit-mode]="estModeEdition" [formGroup]="formulaireUtilisateur" (ngSubmit)="onSubmit()" *ngIf="estModeEdition || !formulaireUtilisateur.value.id">
    <div class="form-section">
      <h3 class="form-section-title">Informations personnelles</h3>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label" for="nom">
            Nom *
            <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
              Le nom de famille de l'utilisateur (minimum 2 caractères)
            </span>
          </label>
          <input
            type="text"
            id="nom"
            class="form-input"
            [class.error]="formulaireUtilisateur.get('nom')?.invalid && formulaireUtilisateur.get('nom')?.touched"
            placeholder="Ex: Kouassi"
            formControlName="nom">
          <span class="error-message" *ngIf="obtenirMessageErreur('nom')">{{ obtenirMessageErreur('nom') }}</span>
        </div>
        <div class="form-group">
          <label class="form-label" for="prenom">
            Prénom(s) *
            <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
              Le prénom de l'utilisateur (minimum 2 caractères)
            </span>
          </label>
          <input
            type="text"
            id="prenom"
            class="form-input"
            [class.error]="formulaireUtilisateur.get('prenom')?.invalid && formulaireUtilisateur.get('prenom')?.touched"
            placeholder="Ex: Jean"
            formControlName="prenom">
          <span class="error-message" *ngIf="obtenirMessageErreur('prenom')">{{ obtenirMessageErreur('prenom') }}</span>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Informations de contact</h3>
      <div class="form-group">
        <label class="form-label" for="email">
          Adresse e-mail *
          <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
            L'adresse e-mail ou le nom d'utilisateur peuvent être utilisés pour se connecter
          </span>
        </label>
        <input
          type="email"
          id="email"
          class="form-input"
          [class.error]="formulaireUtilisateur.get('email')?.invalid && formulaireUtilisateur.get('email')?.touched"
          placeholder="Ex: jean.kouassi@exemple.com"
          formControlName="email">
        <span class="error-message" *ngIf="obtenirMessageErreur('email')">{{ obtenirMessageErreur('email') }}</span>
      </div>

      <div class="form-group" *ngIf="estModeEdition">
        <label class="form-label" for="username">
          Nom d'utilisateur
          <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
            Identificateur unique pour la connexion (3 à 50 caractères) - Optionnel
          </span>
        </label>
        <input
          type="text"
          id="username"
          class="form-input"
          [class.error]="formulaireUtilisateur.get('username')?.invalid && formulaireUtilisateur.get('username')?.touched"
          placeholder="Ex: jean.kouassi"
          formControlName="username">
        <span class="error-message" *ngIf="obtenirMessageErreur('username')">{{ obtenirMessageErreur('username') }}</span>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label class="form-label" for="telephone">
            Téléphone
            <span style="color: var(--text-secondary); font-size: 11px; font-weight: normal; display: block; margin-top: 4px;">
              Numéro à 10 chiffres (optionnel)
            </span>
          </label>
          <input
            type="tel"
            id="telephone"
            class="form-input"
            [class.error]="formulaireUtilisateur.get('telephone')?.invalid && formulaireUtilisateur.get('telephone')?.touched"
            placeholder="07 00 00 00 00"
            formControlName="telephone"
            maxlength="10">
          <span class="error-message" *ngIf="obtenirMessageErreur('telephone')">{{ obtenirMessageErreur('telephone') }}</span>
        </div>
        <div class="form-group">
          <label class="form-label" for="adresse">Adresse</label>
          <input
            type="text"
            id="adresse"
            class="form-input"
            placeholder="Ex: Abidjan, Cocody"
            formControlName="adresse">
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3 class="form-section-title">Sécurité</h3>
      <p style="color: var(--text-secondary); font-size: 13px; margin-bottom: 16px;" *ngIf="!estModeEdition">
        Le mot de passe doit contenir au moins 6 caractères.
      </p>
      <p style="color: var(--text-secondary); font-size: 13px; margin-bottom: 16px;" *ngIf="estModeEdition">
        Laissez vide pour ne pas modifier le mot de passe.
      </p>
      <div class="form-row">
        <div class="form-group">
          <label class="form-label" for="password">
            Mot de passe {{ estModeEdition ? '(optionnel)' : '*' }}
          </label>
          <div class="password-input-wrapper">
            <input
              [type]="masquerMotDePasse ? 'password' : 'text'"
              id="password"
              class="form-input"
              [class.error]="formulaireUtilisateur.get('password')?.invalid && formulaireUtilisateur.get('password')?.touched"
              placeholder="Minimum 6 caractères"
              formControlName="password">
            <button type="button" class="password-toggle-btn" (click)="masquerMotDePasse = !masquerMotDePasse" tabindex="0">
              {{ masquerMotDePasse ? 'Afficher' : 'Masquer' }}
            </button>
          </div>
          <span class="error-message" *ngIf="obtenirMessageErreur('password')">{{ obtenirMessageErreur('password') }}</span>
        </div>
        <div class="form-group" *ngIf="!estModeEdition || formulaireUtilisateur.get('password')?.value">
          <label class="form-label" for="confirmPassword">Confirmer le mot de passe *</label>
          <div class="password-input-wrapper">
            <input
              [type]="masquerConfirmationMotDePasse ? 'password' : 'text'"
              id="confirmPassword"
              class="form-input"
              [class.error]="(formulaireUtilisateur.get('confirmPassword')?.invalid && formulaireUtilisateur.get('confirmPassword')?.touched) || (formulaireUtilisateur.errors?.['passwordMismatch'] && formulaireUtilisateur.get('confirmPassword')?.touched)"
              placeholder="Ressaisissez le mot de passe"
              formControlName="confirmPassword">
            <button type="button" class="password-toggle-btn" (click)="masquerConfirmationMotDePasse = !masquerConfirmationMotDePasse" tabindex="0">
              {{ masquerConfirmationMotDePasse ? 'Afficher' : 'Masquer' }}
            </button>
          </div>
          <span class="error-message" *ngIf="formulaireUtilisateur.errors?.['passwordMismatch'] && formulaireUtilisateur.get('confirmPassword')?.touched">
            Les mots de passe ne correspondent pas
          </span>
        </div>
      </div>
    </div>

    <div class="form-section" style="position: relative; z-index: 2;">
      <h3 class="form-section-title">Profil utilisateur</h3>
      <p style="color: var(--text-secondary); font-size: 13px; margin-bottom: 16px;">
        Le type détermine automatiquement les droits d'accès de l'utilisateur dans l'application.
      </p>

      <!-- Sélecteur de type — cartes visuelles -->
      <div class="form-group">
        <label class="form-label">Type d'utilisateur *</label>
        <div class="type-cards-grid">
          <button
            type="button"
            class="type-card"
            *ngFor="let type of typesUtilisateurs"
            [class.type-card--selected]="formulaireUtilisateur.get('typeUtilisateur')?.value == type.id"
            (click)="formulaireUtilisateur.patchValue({ typeUtilisateur: type.id })">
            <i class="type-card__icon" [class]="roleIcone(deriverRoleDepuisType(type.id))"></i>
            <span class="type-card__label">{{ type.libelle }}</span>
          </button>
        </div>
        <span class="error-message"
              *ngIf="formulaireUtilisateur.get('typeUtilisateur')?.invalid && formulaireUtilisateur.get('typeUtilisateur')?.touched">
          Ce champ est obligatoire
        </span>
        <!-- Champ caché pour la validation réactive -->
        <input type="hidden" formControlName="typeUtilisateur">
      </div>

      <!-- Badge de rôle auto-dérivé -->
      <div class="role-auto-bloc" *ngIf="formulaireUtilisateur.get('role')?.value">
        <div class="role-auto-card" [attr.data-role]="formulaireUtilisateur.get('role')?.value">
          <i [class]="roleIcone(formulaireUtilisateur.get('role')?.value)"></i>
          <div class="role-auto-card__text">
            <strong>{{ roleLibelle(formulaireUtilisateur.get('role')?.value) }}</strong>
            <span>{{ roleDescription(formulaireUtilisateur.get('role')?.value) }}</span>
          </div>
          <span class="role-auto-badge">Auto</span>
        </div>
      </div>
      <div class="chosen-zone-container" *ngIf="doitAfficherZone()">
        <div class="form-group" style="max-width: 520px;">
          <label class="form-label">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="vertical-align: -2px; margin-right: 5px; color: var(--primary-color, #00bfa5);">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            {{ labelZone() }}
          </label>

          <!-- Chosen wrapper multi-select groupé par ville -->
          <div class="chosen-wrapper" [class.chosen-open]="dropdownZoneOuvert" [class.chosen-has-value]="(formulaireUtilisateur.get('zoneIds')?.value || []).length > 0">
            <!-- Trigger -->
            <div class="chosen-trigger" (click)="toggleDropdownZone($event)" tabindex="0" role="combobox" [attr.aria-expanded]="dropdownZoneOuvert" (keydown.enter)="toggleDropdownZone($event)" (keydown.escape)="fermerDropdownZone()">
              <div class="chosen-value-area">
                <ng-container *ngIf="(formulaireUtilisateur.get('zoneIds')?.value || []).length > 0; else zoneVide">
                  <span class="chosen-tag" *ngFor="let z of zonesSelectionnees()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    {{ z?.nom }}
                    <button type="button" class="chosen-tag-clear" (click)="retirerZone(z?.id, $event)" title="Retirer cette zone">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                  </span>
                </ng-container>
                <ng-template #zoneVide>
                  <span class="chosen-placeholder">Sélectionner une zone ou une ville...</span>
                </ng-template>
              </div>
              <div style="display:flex; align-items:center; gap:6px; flex-shrink:0;">
                <button *ngIf="(formulaireUtilisateur.get('zoneIds')?.value || []).length > 0"
                        type="button" class="chosen-clear-all" (click)="effacerZone($event)" title="Tout effacer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
                <svg class="chosen-caret" [class.chosen-caret-up]="dropdownZoneOuvert" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>

            <!-- Dropdown groupé par ville -->
            <div class="chosen-dropdown" *ngIf="dropdownZoneOuvert" role="listbox">
              <div class="chosen-search-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="chosen-search-icon"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                <input
                  type="text"
                  class="chosen-search-input"
                  placeholder="Rechercher une zone ou ville…"
                  [(ngModel)]="rechercheZone"
                  [ngModelOptions]="{ standalone: true }"
                  (input)="filtrerZonesPourChosen()"
                  (click)="$event.stopPropagation()"
                  autofocus>
              </div>

              <div *ngIf="zonesFiltrees.length === 0" class="chosen-empty">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                Aucune zone trouvée
              </div>

              <ng-container *ngFor="let groupe of zonesGroupeesParVille">
                <!-- En-tête ville cliquable -->
                <div class="chosen-ville-header"
                     (click)="selectionnerVille(groupe); $event.stopPropagation()"
                     [class.chosen-ville-selected]="estVilleSelectionnee(groupe)"
                     [class.chosen-ville-partial]="estVillePartielSelectionnee(groupe)">
                  <span class="chosen-ville-checkbox">
                    <svg *ngIf="estVilleSelectionnee(groupe)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    <svg *ngIf="estVillePartielSelectionnee(groupe)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                  <span>{{ groupe.villeNom }}</span>
                  <span class="chosen-ville-count">{{ groupe.zones.length }} zone{{ groupe.zones.length > 1 ? 's' : '' }}</span>
                </div>
                <!-- Zones de la ville -->
                <ul class="chosen-list chosen-list-indented" role="listbox">
                  <li
                    *ngFor="let zone of groupe.zones"
                    class="chosen-item"
                    [class.chosen-item-selected]="estZoneSelectionnee(zone.id)"
                    (click)="selectionnerZone(zone); $event.stopPropagation()"
                    role="option"
                    [attr.aria-selected]="estZoneSelectionnee(zone.id)">
                    <span class="chosen-item-checkbox">
                      <svg *ngIf="estZoneSelectionnee(zone.id)" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="chosen-item-icon"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    <span>{{ zone.nom }}</span>
                  </li>
                </ul>
              </ng-container>
            </div>
          </div>
          <!-- hidden reactive form binding -->
          <input type="hidden" formControlName="zoneIds">
        </div>
      </div>

      <div class="contract-section" *ngIf="estClientSousContratSelectionne()">
        <h3 class="contract-section__title">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
          Détails du contrat
        </h3>

        <div class="form-group">
          <label class="form-label">Base de tarification <span class="required-star">*</span></label>
          <select class="form-select" formControlName="contratBaseTarification">
            <option value="">Sélectionner une base</option>
            <option value="METHODE_ACTUELLE">Poids brut + poids volumétrique (méthode actuelle)</option>
            <option value="PARTICULIERE">Tarification particulière</option>
          </select>
        </div>

        <div class="form-group" *ngIf="formulaireUtilisateur.get('contratBaseTarification')?.value === 'PARTICULIERE'">
          <label class="form-label">Détails de la tarification particulière</label>
          <textarea class="form-textarea"
                    rows="4"
                    placeholder="Ex: grille négociée, remise palier, forfait spécifique..."
                    formControlName="contratTarificationParticuliere"></textarea>
        </div>

        <div class="form-group">
          <label class="form-label">Références / liens des justificatifs</label>
          <textarea class="form-textarea"
                    rows="3"
                    placeholder="Collez les URLs ou références des captures, séparées par virgule"
                    formControlName="contratPiecesJustificatives"></textarea>
          <span class="form-hint">Optionnel — séparez plusieurs liens par une virgule</span>
        </div>

        <div class="form-group">
          <label class="form-label">Joindre des pièces (PDF / images)</label>
          <label class="file-upload-zone">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28" class="file-upload-zone__icon"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
            <span class="file-upload-zone__text">
              <strong>Cliquez pour sélectionner</strong> ou glissez-déposez vos fichiers
            </span>
            <span class="file-upload-zone__hint">PDF, PNG, JPG — plusieurs fichiers acceptés</span>
            <input type="file" multiple (change)="onFichiersContratSelectionnes($event)" style="display:none" />
          </label>
          <div class="upload-actions" *ngIf="fichiersContratSelectionnes.length > 0">
            <span class="upload-count">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
              {{ fichiersContratSelectionnes.length }} fichier(s) sélectionné(s)
            </span>
            <button type="button" class="btn-upload" (click)="uploaderPiecesContrat()" [disabled]="uploadContratEnCours">
              <svg *ngIf="!uploadContratEnCours" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
              {{ uploadContratEnCours ? 'Envoi en cours...' : 'Envoyer les pièces' }}
            </button>
          </div>
        </div>

        <div class="form-group" *ngIf="piecesContratListe().length > 0">
          <label class="form-label">Pièces jointes</label>
          <div class="pieces-grid">
            <div *ngFor="let p of piecesContratListe()" class="piece-card">
              <a [href]="p" target="_blank" rel="noopener" class="piece-link">
                <img *ngIf="pieceEstImage(p)" [src]="p" alt="Pièce contrat" class="piece-thumb" />
                <div *ngIf="pieceEstPdf(p)" class="piece-fallback">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                  PDF
                </div>
                <div *ngIf="!pieceEstImage(p) && !pieceEstPdf(p)" class="piece-fallback">Fichier</div>
                <small class="piece-url">{{ p | slice:0:30 }}…</small>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Informations RH (optionnel) ────────────────────────────── -->
    <div class="form-section" style="position: relative;">
      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom: 12px;">
        <div>
          <h3 class="form-section-title" style="margin-bottom: 4px;">Informations RH</h3>
          <p style="color: var(--text-secondary); font-size: 13px; margin: 0;">
            Activez cette section pour créer également une fiche RH (contrat, rémunération, points). Optionnel.
          </p>
        </div>
        <label class="rh-toggle">
          <input type="checkbox" [(ngModel)]="activerInfoRH" [ngModelOptions]="{ standalone: true }">
          <span class="rh-toggle-slider"></span>
          <span class="rh-toggle-label">{{ activerInfoRH ? 'Activée' : 'Désactivée' }}</span>
        </label>
      </div>

      <div *ngIf="activerInfoRH" class="rh-content">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Matricule</label>
            <input formControlName="rhNumeroMatricule" class="form-input" placeholder="Ex: RH-001">
          </div>
          <div class="form-group">
            <label class="form-label">Poste</label>
            <input formControlName="rhPoste" class="form-input" placeholder="Livreur, Chauffeur, Manutentionnaire...">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Type de contrat</label>
            <select formControlName="rhTypeContrat" class="form-input">
              <option *ngFor="let t of typesContratRH" [value]="t">{{ libellesRH[t] }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Mode de rémunération</label>
            <select formControlName="rhModeRemuneration" class="form-input">
              <option *ngFor="let m of modesRemunRH" [value]="m">{{ libellesRH[m] }}</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group" *ngIf="rhModeCourant === 'MENSUEL' || rhModeCourant === 'MIXTE'">
            <label class="form-label">Salaire de base (FCFA)</label>
            <input type="number" formControlName="rhSalaireBase" class="form-input" min="0" placeholder="Ex: 150 000">
          </div>
          <div class="form-group" *ngIf="rhModeCourant === 'PAR_LIVRAISON' || rhModeCourant === 'MIXTE'">
            <label class="form-label">Tarif par livraison (FCFA)</label>
            <input type="number" formControlName="rhTarifParLivraison" class="form-input" min="0" placeholder="Ex: 500">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Date d'embauche</label>
            <input type="date" formControlName="rhDateEmbauche" class="form-input">
          </div>
          <div class="form-group">
            <label class="form-label">Date de fin (si CDD)</label>
            <input type="date" formControlName="rhDateFin" class="form-input">
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Notes</label>
          <textarea formControlName="rhNotes" class="form-input" rows="2" placeholder="Observations RH..."></textarea>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <a class="btn btn-secondary" style="cursor:pointer;" (click)="naviguerRetour()">Annuler</a>
      <button type="submit" class="btn btn-primary" [disabled]="chargement || formulaireUtilisateur.invalid">
        {{ chargement ? 'Création en cours...' : (estModeEdition ? 'Enregistrer les modifications' : 'Créer l\'utilisateur') }}
      </button>
    </div>

    <app-spinner *ngIf="chargement"></app-spinner>
  </form>
</section>
